<!-- 组件说明 -->
<template>
  <div class="">
    <div v-for="(item, index) in statusList" :key="index">
      <div
        :class="['customer', item.value === customerStatus ? 'isSelect' : '']"
        @click="selectStatus(item)"
      >
        {{ item.label }}
      </div>
      <div class="line"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    customerStatus: {
      type: Number,
    },
    statusList: {
      type: Array,
    },
  },
  methods: {
    selectStatus(item) {
      if (item.value !== this.customerStatus) {
        this.$emit("changeCustomerStatus", item);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.customer {
  height: 80px;
  background: #ffffff;
  line-height: 80px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  text-align: center;

  &.isSelect {
    color: #0d9869;
  }
}
.line {
  width: 690px;
  height: 1px;
  background: #efefef;
}
</style>
